<template>
  <div class="PersonalReport">
    <div class="select">
      <a-select class="option" placeholder="筛选年级" style="width: 120px" @change="handleChangeGrade" @keyup.enter.native="searchHandle" allowClear>
        <a-select-option v-for="item in schoolGrades" :key="item" :value="item">{{item}}</a-select-option>
      </a-select>
      <a-select class="option" placeholder="筛选班级" style="width: 120px" @change="handleChangeClass" @keyup.enter.native="searchHandle" allowClear>
        <a-select-option v-for="item in classChangeList" :key="item" :value="item">{{item}}</a-select-option>
      </a-select>
      <a-input placeholder="学生姓名" v-model="stuName" @keyup.enter.native="searchHandle"/>
      <a-button class="commit" type="primary" @click="searchHandle">查询</a-button>
    </div>
    <div class="reortTable">
      <a-table :columns="columns" :dataSource="personalInfo" :rowKey="row => row.ID" :pagination="{ pageSize: 10 }">
        <template slot="REAL_NAME" slot-scope="text">{{text}}</template>
        <template slot="SEX_V" slot-scope="text">{{text}}</template>
        <template slot="GRADE" slot-scope="text">{{text}}</template>
        <template slot="CLASS" slot-scope="text" width="30%">{{text}}</template>
        <template slot="operation" slot-scope="text, record">
          <a :href="getReportUrl(record)" target="_blank">查看报告</a>
          <a style="margin-left: 28px" @click="repeatTestHandle(record)">重做</a>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import STUDENTFUN from '@/util/studentFun'
  import GRADENEW from '@/util/gradeNew'
  import URL from '@/store/url'
  import md5 from 'blueimp-md5'
  export default {
    name: 'PersonalReport',
    data () {
      return {
        columns: [
          {
            title: '姓名',
            dataIndex: 'REAL_NAME',
            key: 'REAL_NAME',
            scopedSlots: { customRender: 'REAL_NAME' }
          },
          {
            title: '性别',
            dataIndex: 'SEX_V',
            key: 'SEX_V',
            scopedSlots: { customRender: 'SEX_V' }
          },
          {
            title: '年级',
            dataIndex: 'GRADE',
            key: 'GRADE',
            scopedSlots: { customRender: 'GRADE' }
          },
          {
            title: '班级',
            dataIndex: 'CLASS',
            key: 'CLASS',
            width: '40%',
            scopedSlots: { customRender: 'CLASS' }
          },
          {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            scopedSlots: { customRender: 'operation' }
          }
        ],
        stuName: null,
        gradeVal: null,
        classArr: null,
        gradeClassAll: null,
        personalInfo: [],
        personalInfoAll: [],
      }
    },
    computed: {
      ...mapState([
        'teacherAdmin',
        'schoolGrades',
        'classReport',
        'personalReport',
        'repeatTest',
        'taskReport'
      ]),
      classChangeList () {
        let list = null
        if (this.gradeVal) {
          this.gradeClassAll.classMaps.forEach((val, key) => {
            if (this.gradeVal === GRADENEW(key).gradeListSimple) {
              list = val
            }
          })
        } else {
          if (this.gradeClassAll) {
            list = this.gradeClassAll.classArr
          } 
        }
        return list
      }
    },
    methods: {
      ...mapActions([
        'getPersonalReport',
        'getRepeatTest'
      ]),
      repeatTestHandle (record) {
        console.log(record)
        console.log(this.taskReport)
        if (new Date(new Date() - 24 * 60 * 60 * 1000) < new Date(this.taskReport.end_time)) {
          this.$confirm({
            title: '学生重做测评任务',
            content: '重做会放弃本次测评数据，以下次重做的数据代替，确定要重做吗？',
            okText: '重做',
            okType: 'danger',
            cancelText: '取消',
            onOk: async () => {
              console.log('重做')
              await this.getRepeatTest(record)
              if (this.repeatTest) {
                await this.pubFun()
                this.$message.success('报告已删除，请联系学生重做')
              } else {
                this.$message.error('操作失败')
              }
            },
            onCancel() {
              console.log('Cancel')
            },
          })
        } else {
          this.$message.warning('测评已结束')
        }
      },
      handleChangeGrade(value) {
        this.gradeVal = value
      },
      handleChangeClass(value) {
        this.classVal = value
      },
      getReportUrl(record){
        return `${URL.TO_PERSON_REPORT}?questionnaireId=${this.taskReport.qid}&studentUid=${record.UID}&teacherUid=${this.teacherAdmin.uid}&cityId=${this.teacherAdmin.city}&tokenValue=${md5(this.taskReport.qid + 'AAA' + record.UID + 'BBB')}&token=${this.teacherAdmin.tokenValue}&roleId=${JSON.parse(sessionStorage.getItem('userInfo')).role_id}&schoolType=1`
      },
      searchHandle(){
        this.personalInfo = this.personalInfoAll.filter((item) => !this.gradeVal ? true : item.GRADE === this.gradeVal).filter((item) => !this.classVal ? true : item.CLASS === this.classVal).filter((item) => !this.stuName ? true : item.REAL_NAME.indexOf(this.stuName) !== -1)
      },
      async pubFun () {
        this.personalInfo = []
        this.personalInfoAll = []
        let class_list = JSON.parse(sessionStorage.getItem('userInfo')).class_list
        if (JSON.parse(sessionStorage.getItem('userInfo')).role_id === 3) { // 班主任
          if (class_list && class_list.length) {
            await this.getPersonalReport()
            this.personalReport.map((item,index) =>{
              let info = {
                ID: index,
                UID: item.UID,
                REAL_NAME: item.REAL_NAME,
                SEX_V: item.SEX == '1' ? '男' : '女',
                GRADE: GRADENEW(item.GRADE_ID).gradeListSimple,
                CLASS: item.CLASS_ID + '班',
                GRADE_ID: item.GRADE_ID,
                CLASS_ID: item.CLASS_ID //.substring(0,item.CLASS.indexOf("班"))
              }
              this.personalInfo.push(info)
              this.personalInfoAll.push(info)
            })
            this.gradeClassAll = STUDENTFUN.uploadClass(this.personalInfoAll)
          }
        } else { // 其他权限角色
          await this.getPersonalReport()
          this.personalReport.map((item,index) =>{
            let info = {
              ID: index,
              UID: item.UID,
              REAL_NAME: item.REAL_NAME,
              SEX_V: item.SEX == '1' ? '男' : '女',
              GRADE: GRADENEW(item.GRADE_ID).gradeListSimple,
              CLASS: item.CLASS_ID + '班',
              GRADE_ID: item.GRADE_ID,
              CLASS_ID: item.CLASS_ID //.substring(0,item.CLASS.indexOf("班"))
            }
            this.personalInfo.push(info)
            this.personalInfoAll.push(info)
          })
          this.gradeClassAll = STUDENTFUN.uploadClass(this.personalInfoAll)
        }
      }
    },
    async mounted () {
      await this.pubFun()
    }
  }
</script>

<style>
.PersonalReport .select{
  display: flex;
  margin-left: 40px;
  padding: 24px 0px;
}
.PersonalReport .select .ant-btn-primary{
  width:64px;
  height:32px;
  background: rgba(81,191,148,1);
  border-radius: 4px;
  border-color: rgba(81,191,148,1);
}
.PersonalReport .select .option{
  width: 120px;
  margin-right: 16px;
}
.PersonalReport .select > input{
  width: 180px;
  height: 32px;
  margin-right: 14px;
}
.PersonalReport .select .ant-btn > span {
  color: #ffffff;
}
.PersonalReport .ant-table-thead > tr > th, .PersonalReport .ant-table-tbody > tr > td {
  padding: 16px 40px!important;
}
</style>